import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  transform(value: any, args: any, type?: string): unknown {
    if (!args) return value;
    if (type === 'full') {
      const re = new RegExp('\\b(' + args + '\\b)', 'igm');
      value = value.replace(re, '<span class="uiHighlighted">$1</span>');
    } else {
      const re = new RegExp(args, 'igm');
      value = value.replace(re, '<span class="uiHighlighted">$&</span>');
    }
    return value;
  }
}
